import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const BottomTabNavigation = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const tabs = [
        {
            id: 'home',
            label: 'Home',
            path: '/home-screen',
            icon: 'Home'
        },
        {
            id: 'search',
            label: 'Search',
            path: '/service-listing-screen',
            icon: 'Search'
        },
        {
            id: 'bookings',
            label: 'Bookings',
            path: '/bookings',
            icon: 'Calendar'
        },
        {
            id: 'profile',
            label: 'Profile',
            path: '/profile',
            icon: 'User'
        }
    ];

    const handleTabClick = (tab) => {
        navigate(tab?.path);
    };

    const isActive = (path) => {
        return location?.pathname === path;
    };

    return (
        <nav className="bottom-tab-nav">
            <div className="bottom-tab-nav-container">
                {tabs?.map((tab) => (
                    <button
                        key={tab?.id}
                        onClick={() => handleTabClick(tab)}
                        className={`bottom-tab-item touch-target active:scale-95 ${isActive(tab?.path) ? 'active' : ''}`}
                        aria-label={tab?.label}
                        aria-current={isActive(tab?.path) ? 'page' : undefined}
                    >
                        <Icon
                            name={tab?.icon}
                            size={isActive(tab?.path) ? 26 : 24}
                            strokeWidth={isActive(tab?.path) ? 2.5 : 2}
                            className="transition-all duration-200"
                        />
                        <span className="bottom-tab-label">{tab?.label}</span>
                    </button>
                ))}
            </div>
        </nav>
    );
};

export default BottomTabNavigation;